import { z } from 'zod'

export type ImportInspectionSchema = z.infer<typeof ImportInspectionSchema>

export const defaultValues: ImportInspectionSchema = {
  inspection_slug: '',
  component: '',
  job: '',
  unit: '',
  site: '',
  organization: '',
}

const requiredString = (entryType: string) =>
  z.string({ message: `${entryType} selection is required` })

export const ImportInspectionSchema = z.object({
  inspection_slug: z.string({ message: 'Inspection slug is required' }),
  component: requiredString('Component'),
  job: requiredString('Job'),
  unit: requiredString('Unit'),
  site: requiredString('Site'),
  organization: requiredString('Organization'),
})
